import { type InsuranceCorporateIdentity } from "../types";

export function BertelsmannBKKLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M183.305 391.774L244.468 391.754C292.347 391.754 325.848 370.357 325.848 331.613C325.848 282.438 283.589 262.181 230.162 262.181H213.424L232.498 219.652C260.695 219.652 309.402 215.067 309.402 163.636C309.402 139.667 293.612 115.406 241.11 115.406H183.305V391.779L183.305 391.774ZM130 72H246.731C331.493 72 364.751 113.922 364.751 161.933C364.751 199.002 340.86 223.796 317.285 236.63C346.358 247.717 382 271.734 382 327.775C382 384.423 342.66 436 245.733 436H130V72Z"
        fill="white"
      />
    </svg>
  );
}

export const BertelsmannBKK: InsuranceCorporateIdentity = {
  id: "bertelsmann-bkk",
  name: "Bertelsmann BKK",
  logo: BertelsmannBKKLogo,
  backgroundColor: "#003063",
  textColor: "#FFFFFF",
  wildcard: "bertelsmann bkk",
  type: "statutory",
};
